module.exports = __webpack_public_path__ + "img/szhx_titIcon4.25b1d604.png";